import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  textColor?: string;
  withText?: boolean;
}

export const Logo: React.FC<LogoProps> = ({ 
  size = 'medium', 
  textColor = 'text-white',
  withText = false
}) => {
  // Size mapping
  const sizeMap = {
    small: 'h-8',
    medium: 'h-12',
    large: 'h-16'
  };

  return (
    <Link to="/" className="flex items-center">
      <img 
        src="/Agilis AI Clinical Solution.png" 
        alt="Agilis AI Clinical Solution" 
        className={`${sizeMap[size]}`}
      />
      {withText && (
        <span className={`ml-2 font-semibold ${textColor}`}>
          <span className="text-red-500 font-bold">AGILIS</span> 
          <span className={textColor}>AI</span>
        </span>
      )}
    </Link>
  );
};

export default Logo; 